import {
  StaffAgreementResponse,
  StaffAgreementSignatureResponse,
  StaffAgreementTemplateResponse,
} from "lib-klab-sdks";
import {
  AgreementTemplate,
  AgreementSignature,
  EmploymentAgreement,
} from "../../../domain/models/employment/agreement.model";

export const mapEmploymentAgreement = (
  source: StaffAgreementResponse,
): EmploymentAgreement => ({
  id: source.agreementId,
  number: source.agreementNumber,
  type: source.type,
  title: source.title,
  templateId: source.templateId,
  sourceType: source.sourceType,
  sourceReferenceId: source.sourceReferenceId,
  parentAgreementId: source.parentAgreementId,
  startDate: source.startDate,
  endDate: source.endDate,
  status: source.status,
  currentVersion: source.currentVersion,
  documentUrl: source.currentDocumentUrl,
  variables: source.variables,
  parties: source.parties.map((party) => ({
    id: party.partyId,
    agreementId: party.agreementId,
    role: party.role,
    type: party.type,
    referenceId: party.referenceId,
    displayName: party.displayName,
    email: party.email,
    signingOrder: party.signingOrder,
    required: party.required,
    createdAt: party.createdAt,
  })),
  generatedAt: source.generatedAt,
  submittedAt: source.submittedAt,
  effectiveAt: source.effectiveAt,
  terminatedAt: source.terminatedAt,
  terminationReason: source.terminationReason,
  createdAt: source.createdAt,
  updatedAt: source.updatedAt,
});

export const mapAgreementTemplate = (
  source: StaffAgreementTemplateResponse,
): AgreementTemplate => ({
  id: source.templateId,
  code: source.code,
  version: source.version,
  type: source.type,
  name: source.name,
  description: source.description,
  content: source.content,
  status: source.status,
});

export const mapAgreementSignature = (
  source: StaffAgreementSignatureResponse,
): AgreementSignature => ({
  id: source.signatureId,
  agreementId: source.agreementId,
  versionId: source.versionId,
  partyId: source.partyId,
  status: source.status,
  provider: source.provider,
  externalSignatureId: source.externalSignatureId,
  evidenceUrl: source.evidenceUrl,
  signedByUserId: source.signedByUserId,
  requestedAt: source.requestedAt,
  signedAt: source.signedAt,
  updatedAt: source.updatedAt,
});
